import { useTranslation } from "@refinedev/core"
import dayjs from "dayjs"
import { calendar_v3 } from "googleapis"
import { HTMLAttributes, useMemo, useState } from "react"
import { FaPhone } from "react-icons/fa6"

export interface EmergencyEventProps extends HTMLAttributes<HTMLDivElement> {
    event: calendar_v3.Schema$Event
    update?: boolean
}

export const EmergencyEvent = ({ event, update = false, className, ...rest }: EmergencyEventProps) => {
    const date = useMemo(() => dayjs(), [update])
    const { translate } = useTranslation()
    const [copy, setCopy] = useState(translate("calendar-defs.emergency_call-modal.copy"))
    const meetLink = event?.conferenceData?.entryPoints?.[0]?.uri!
    // logger.debug(date.toISOString())

    const copyText = () => {
        navigator.clipboard.writeText(meetLink);
        setCopy(translate("calendar-defs.emergency_call-modal.copied") + "!")
        setTimeout(() => {
            setCopy(translate("calendar-defs.emergency_call-modal.copied"))
        }, 2000)
    }

    return <div className={`flex flex-col items-center ${className ?? ''}`} {...rest}>
        <div className="card shadow-lg">
            <div className="group card-title gap-4  items-center text-base-100 bg-secondary p-4 pl-8 relative overflow-hidden">
                <FaPhone className="w-12 h-12 text-red-400 group-hover:animate-shake" />
                <h1 className="text-2xl uppercase font-bold w-64">{translate("calendar-defs.emergency_call-modal.title")}</h1>
                <img className="absolute bottom-0 right-0 w-24 -mb-2 -mr-2 group-hover:-mb-1 group-hover:-mr-1 transition-all" src="/img/hachi-corner.png" alt="" />
            </div>
            <div className="card-body bg-base-200">
                {/* <a className="link" href={emergencyEvent.htmlLink!}>Link del evento</a> */}
                <fieldset className="fieldset">
                    <legend>{translate("calendar-defs.emergency_call-modal.subtitle")}</legend>
                    <span className="font-normal text-sm">{`${date.to(dayjs(event.start?.dateTime))},`} <strong>{`${dayjs(event.start?.dateTime).format('HH:mm')} - ${dayjs(event.end?.dateTime).format('HH:mm')}`}</strong></span>
                    <a className="my-2 btn btn-secondary hover:scale-[1.02]" href={meetLink} target="_blank">
                        {translate("calendar-defs.emergency_call-modal.short-description")}
                    </a>
                    <div className="label">
                        <span className="cursor-copy tooltip" data-tip={copy} onClick={copyText}>{meetLink}</span>
                    </div>
                </fieldset>
            </div>
        </div>
    </div>
}